"use strict";
/**
 * Copyright 2019-2023 Denis Haev (bluefox) <dogafox@gmail.com>
 *
 * MIT License
 *
 **/
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// please do not delete React, as without it other projects could not be compiled: ReferenceError: React is not defined
const react_1 = __importStar(require("react"));
const styles_1 = require("@mui/styles");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const i18n_1 = __importDefault(require("../i18n"));
const styles = {
    suppress: {
        fontSize: 12,
    },
    suppressRoot: {
        marginTop: 16,
    },
};
/**
 * @property title The dialog title; default: Are you sure? (translated)
 * @property text The dialog text.
 * @property ok The ok button text; default: OK (translated)
 * @property cancel The cancel button text; default: Cancel (translated)
 * @property suppressQuestionMinutes interval in minutes for which the confirmation dialog will be suppressed if activated.
 * @property suppressText The suppress checkbox text; default: Suppress question for next %s minutes (translated)
 * @property dialogName Name of the dialog. Used only with suppressQuestionMinutes to store the user choice
 * @property onClose Close handler.
 */
class DialogConfirm extends react_1.Component {
    constructor(props) {
        super(props);
        if (!this.props.dialogName && this.props.suppressQuestionMinutes) {
            throw new Error('dialogName required if suppressQuestionMinutes used');
        }
        let suppress = false;
        if (this.props.suppressQuestionMinutes) {
            suppress = parseInt((window._localStorage || window.localStorage).getItem(this.props.dialogName), 10) || 0;
            if (!suppress) {
                suppress = false;
            }
            else if (Date.now() > suppress) {
                (window._localStorage || window.localStorage).removeItem(this.props.dialogName);
                suppress = false;
            }
        }
        this.state = {
            suppress,
        };
    }
    handleOk() {
        if (this.state.suppress) {
            (window._localStorage || window.localStorage).setItem(this.props.dialogName, Date.now() + (this.props.suppressQuestionMinutes || 2) * 60000);
        }
        this.props.onClose && this.props.onClose(true);
    }
    handleCancel() {
        this.props.onClose && this.props.onClose(false);
    }
    render() {
        if (typeof this.state.suppress === 'number') {
            setTimeout(() => this.props.onClose && this.props.onClose(true), 100);
            return null;
        }
        return react_1.default.createElement(material_1.Dialog, { open: !0, maxWidth: "md", fullWidth: this.props.fullWidth !== undefined ? this.props.fullWidth : true, onClose: (event, reason) => {
                if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                    this.handleCancel();
                }
            }, "aria-labelledby": "ar_confirmation_dialog_title", "aria-describedby": "ar_confirmation_dialog_description" },
            react_1.default.createElement(material_1.DialogTitle, { id: "ar_confirmation_dialog_title" }, this.props.title || i18n_1.default.t('ra_Are you sure?')),
            react_1.default.createElement(material_1.DialogContent, null,
                react_1.default.createElement(material_1.DialogContentText, { id: "ar_confirmation_dialog_description" },
                    this.props.icon || null,
                    this.props.text,
                    this.props.suppressQuestionMinutes ? react_1.default.createElement("br", null) : null,
                    this.props.suppressQuestionMinutes ? react_1.default.createElement(material_1.FormControlLabel, { classes: { label: this.props.classes.suppress, root: this.props.classes.suppressRoot }, control: react_1.default.createElement(material_1.Checkbox, { id: `ar_dialog_confirm_suppress_${this.props.dialogName || ''}`, checked: !!this.state.suppress, onChange: () => this.setState({ suppress: !this.state.suppress }) }), label: this.props.suppressText || i18n_1.default.t('ra_Suppress question for next %s minutes', (this.props.suppressQuestionMinutes || 2).toString()) }) : null)),
            react_1.default.createElement(material_1.DialogActions, null,
                react_1.default.createElement(material_1.Button, { id: `ar_dialog_confirm_ok_${this.props.dialogName || ''}`, variant: "contained", onClick: () => this.handleOk(), color: "primary", autoFocus: true, startIcon: react_1.default.createElement(icons_material_1.Check, null) }, this.props.ok || i18n_1.default.t('ra_Ok')),
                react_1.default.createElement(material_1.Button, { id: `ar_dialog_confirm_cancel_${this.props.dialogName || ''}`, variant: "contained", onClick: () => this.handleCancel(), 
                    // @ts-expect-error
                    color: "grey", startIcon: react_1.default.createElement(icons_material_1.Close, null) }, this.props.cancel || i18n_1.default.t('ra_Cancel'))));
    }
}
const _export = (0, styles_1.withStyles)(styles)(DialogConfirm);
exports.default = _export;
